export const Bills = {
    LOADING_BILLS_LIST: "LOADING_BILLS_LIST",
    GET_BILLS_LIST: "GET_BILLS_LIST",
  };